import React from 'react'

export default function AnalisisDeEstrategia({ strategicRules = null, expediente = {}, contextoDictamen = null }) {
  const meta = strategicRules?.caseMeta || {}
  const cese = String(expediente?.fechaCese || '')
  const ceseYear = Number((cese.match(/^(\d{4})/) || [])[1] || 0)
  const indiceElegido = ceseYear > 0 && ceseYear < 2017 ? 'ISBIC' : 'RIPTE'
  const fundamentoIndice = indiceElegido === 'ISBIC'
    ? 'Se selecciono ISBIC porque el cese es anterior a 2017, garantizando la aplicacion del Fallo Elliff.'
    : 'Se selecciono RIPTE porque el cese es posterior a 2017, conforme pauta del Fallo Blanco.'
  const descarte = 'Se descartaron alternativas que incrementaban la quita y deterioraban la razonabilidad del haber reajustado.'
  const movilidad = meta.puenteRequerido
    ? 'Se aplico puente de movilidad por brecha temporal relevante entre cese y fecha actual.'
    : 'No se aplico puente de movilidad por no verificarse brecha temporal relevante.'

  if (!contextoDictamen && !strategicRules) return null

  return (
    <section className="mt-4 rounded-2xl border border-white/20 bg-white/10 p-4 backdrop-blur-2xl">
      <p className="text-xs uppercase tracking-wide text-slate-300">Memoria de Analisis Forense</p>
      <div className="mt-3 space-y-3 text-sm text-slate-100">
        <div className="rounded-lg border border-cyan-300/30 bg-cyan-500/10 p-3">
          <p className="font-semibold">Decision: Seleccion de Indice</p>
          <p className="mt-1 text-xs">Fundamento: {fundamentoIndice}</p>
        </div>
        <div className="rounded-lg border border-rose-300/30 bg-rose-500/10 p-3">
          <p className="font-semibold">Decision: Descarte de opciones alternativas</p>
          <p className="mt-1 text-xs">Fundamento: {descarte}</p>
        </div>
        <div className="rounded-lg border border-amber-300/30 bg-amber-500/10 p-3">
          <p className="font-semibold">Decision: Logica de Movilidad</p>
          <p className="mt-1 text-xs">Fundamento: {movilidad}</p>
        </div>
      </div>
    </section>
  )
}
